import React from 'react';
import './WelcomeComponent.css';
import useSettings from '../hooks/useSettings';

const WelcomeComponent = () => {
  const { getSetting } = useSettings();
  const welcomeContent = getSetting('welcome_content', '');
  return (
    <div className="welcome-component">
      <img src="img/karl-b-gpt.png" alt="Karl B – Your Personal Advocacy Assistant!" className="welcome-avatar" />
      {welcomeContent ? (
        <div className="welcome-copy" dangerouslySetInnerHTML={{ __html: welcomeContent }} />
      ) : (
        <div className="welcome-copy">
          <h1>Hello, I'm Karl B!</h1>
          <h2>Your Personal Advocacy Assistant!</h2>
          <p>Let me help you with your advocacy questions and needs.</p>
        </div>
      )}
    </div>
  );
};

export default WelcomeComponent;
